(function () {
    'use strict';

    angular
        .module('ib-modal-module')
        .service('PmtModalService', PmtModalService);

    PmtModalService.$inject = ['$rootScope', '$uibModal','CommonsModalService'];
    function PmtModalService($rootScope, $uibModal, CommonsModalService) {

        const self = this;
        angular.extend(this, CommonsModalService);

        self.showGenericError = showGenericError;
        self.showGenericModal = showGenericModal;
        self.showFilterModal = showFilterModal;
        self.showLoginModal = showLoginModal;
        self.openInsuranceModal = openInsuranceModal;
        self.showNewOrSameFlightModal = showNewOrSameFlightModal;

        ////////////////
        /**
         * Opens a generic error modal returning its instance
         * @param {Object} errorObject - the error object to show in the template. It is passed to the controller.
         * @param {boolean} isModalBlocked - if the error modal must be blocked on outside user click.
         * @param {string} template - the name of a custom template to be shown in the modal
         * @returns {Object} -the error modal instance opened
         */
        function showGenericError(errorObject, isModalBlocked, template) {
            var modalErrorObject = {
                animation: false,
                templateUrl: $rootScope.routes.templates + (template ? (template + '.html') : 'pmt-generic-error-modal.html'),
                controller: 'PaymentGenericErrorModalController',
                controllerAs: 'modalCtrl',
                windowClass: 'ib-modals ib-modals--md',
                resolve: {
                    errorObject: function () {
                        return errorObject;
                    }
                }
            };

            if (isModalBlocked) {
                modalErrorObject['backdrop'] = 'static';
                modalErrorObject['keyboard'] = false;
            }
            return $uibModal.open(modalErrorObject);
        }

        ////////////////
        /**
         * Opens a generic  modal returning its instance
         * @param {boolean} isModalBlocked - if the  modal must be blocked on outside user click.
         * @param {string} template - the name of a custom template to be shown in the modal
         * @returns {Object} -the  modal instance opened
         */
        function showGenericModal(isModalBlocked, template, modelObject, extraModalClass) {
            var modalObject = {
                animation: false,
                templateUrl: $rootScope.routes.templates + template,
                controller: 'PaymentGenericModalController',
                controllerAs: 'modalCtrl',
                windowClass: 'ib-modals' + (extraModalClass ? ' ' + extraModalClass : ' ib-modals--md'),
                resolve: {
                    object: function () {
                        return modelObject;
                    }
                }
            };
            if (isModalBlocked) {
                modalObject['backdrop'] = 'static';
                modalObject['keyboard'] = false;
            }
            return $uibModal.open(modalObject);
        }

        ////////////////
        /**
         * Opens an especial filter  modal returning its instance
         * @param {string} template - the name of a custom template to be shown in the modal
         * @returns {Object} -the  modal instance opened
         */
        function showFilterModal(template, modelObject, animationEnabled, clss, controller, controllerAs) {
            var modalObject = {
                animation: animationEnabled,
                templateUrl: $rootScope.routes.templates + template + '.html',
                controller: controller,
                controllerAs: controllerAs,
                windowClass: clss ? clss : 'ib-modals',
                resolve: {
                    object: function () {
                        return modelObject;
                    }
                }
            };
            return $uibModal.open(modalObject);
        }

        ////////////////
        /**
         * Opens an especial filter  modal returning its instance
         * @param {string} template - the name of a custom template to be shown in the modal
         * @returns {Object} -the  modal instance opened
         */
        function showLoginModal(template, modelObject, animationEnabled, clss) {
            var modalObject = {
                animation: animationEnabled,
                templateUrl: $rootScope.routes.templates + template + '.html',
                controller: 'PaymentGenericModalController',
                controllerAs: 'modalCtrl',
                windowClass: clss ? clss : 'ib-modals',
                resolve: {
                    object: function () {
                        return modelObject;
                    }
                }
            };
            return $uibModal.open(modalObject);
        }


      
        ////////////////
        /**
         * Opens a generic  modal returning its instance
         * @param {Object} modelObject - An object to be used in the view. This object will be associated to the 
         * @param {string} template - the name of a custom template to be shown in the modal
         * modalCtrl.model object in the generic controller
         * @returns {Object} -the  modal instance opened
         */
        function openInsuranceModal(modelObject, tpl) {
            var modalObject = {
                animation: false,
                templateUrl: $rootScope.routes.templates + tpl + '.html',
                controller: 'InsuranceModalController',
                controllerAs: 'modalCtrl',
                windowClass: 'ib-modals ib-modals--right fade',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    object: function () {
                        return modelObject;
                    }
                }
            };
            return $uibModal.open(modalObject);
        }

        function showNewOrSameFlightModal(errorObject, isModalBlocked, template) {
            var modalErrorObject = {
                animation: false,
                templateUrl: $rootScope.routes.templates + template + '.html',
                controller: 'PaymentGenericErrorModalController',
                controllerAs: 'modalCtrl',
                windowClass: 'ib-modals ib-modals--md',
                resolve: {
                    errorObject: function () {
                        return errorObject;
                    }
                }
            };

            if (isModalBlocked) {
                modalErrorObject['backdrop'] = 'static';
                modalErrorObject['keyboard'] = false;
            }
            return $uibModal.open(modalErrorObject);
        }
    }
})();